import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57fc6bce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TTN" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_form = _resolveComponent("search-form")!
  const _component_ttn_list = _resolveComponent("ttn-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_search_form, {
      loading: _ctx.state.is_loading,
      failed: _ctx.state.is_failed,
      onSubmit: _ctx.onSubmit
    }, null, 8, ["loading", "failed", "onSubmit"]),
    _createVNode(_component_ttn_list, {
      loading: _ctx.state.is_loading,
      failed: _ctx.state.is_failed,
      items: _ctx.state.list,
      class: "mt-3"
    }, null, 8, ["loading", "failed", "items"])
  ]))
}